
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikcabs() {



    const cardData =
    {
        keyword: 'Pune to Nasik Cabs',
        heading: 'Platinum24 Cabs: Pune to Nasik Cabs',
        headingDescription: 'Platinum24 Cabs offers dependable Pune to Nasik Cabs for business, leisure, and pilgrimage travel. With a fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cars, we ensure a smooth and comfortable ride on this important intercity route. Our professional drivers are experienced with the Pune–Nasik highway, guaranteeing safe and punctual travel for every passenger. Whether you need a one-way drop, round-trip booking, or multi-day cab hire, Platinum24 Cabs provides affordable fares, transparent pricing, and 24/7 availability to make your Pune to Nasik journey stress-free and reliable.',

        top: 'Top Places to Visit in Nasik with Platinum24 Cabs',

        "topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "Trimbakeshwar Temple, located 28 km from Nashik, is one of the 12 Jyotirlingas of Lord Shiva. Built in Nagara style by the Peshwas, the temple sits at the origin of the holy Godavari River. Its sanctum houses three lingas symbolizing Brahma, Vishnu, and Shiva. Devotees believe visiting here washes away sins and grants moksha. Rituals like Narayan Nagbali are performed here. Trimbakeshwar is Nashik’s most sacred pilgrimage site."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s premier wine destination located in the outskirts of Nashik. Spread across lush vineyards, it offers tours of the winery, wine-tasting sessions, and fine dining experiences. Tourists enjoy walking among the vines, learning wine-making, and relaxing in its resort. The annual SulaFest attracts music and wine lovers from across the country. The vineyard sunsets are breathtaking. Sula Vineyards is Nashik’s modern hub of wine tourism."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a sacred area in Nashik associated with the Ramayana. Legends say Lord Rama, Sita, and Lakshmana lived here during exile. The Kalaram Temple, Sita Gufa, and Tapovan are key attractions. Devotees believe the Godavari River here is holy and perform rituals along its ghats. Pilgrims visit year-round, especially during Kumbh Mela. Panchavati is Nashik’s divine spiritual destination."
  },
  {
    "title": "Ramkund",
    "description": "Ramkund is a sacred bathing ghat on the Godavari River in the Panchavati area of Nashik. It is believed that Lord Rama bathed here during exile. Pilgrims take holy dips, especially during Kumbh Mela, to wash away sins. The ghat is also the place for performing rituals and last rites. Its spiritual energy attracts devotees daily. Ramkund is Nashik’s spiritual riverfront of devotion and rituals."
  },
  {
    "title": "Pandavleni Caves",
    "description": "Pandavleni Caves, also known as Trirashmi Caves, are 2000-year-old Buddhist rock-cut caves near Nashik. They feature intricate viharas, chaityas, and inscriptions. Carved by Satavahana rulers, the caves reflect Buddhist philosophy and art. Trekkers enjoy climbing the hill for stunning views of the city. It is a favorite for history lovers and photographers. Pandavleni Caves are Nashik’s treasure of ancient architecture and spirituality."
  },
  {
    "title": "Kalaram Temple",
    "description": "Kalaram Temple in Panchavati is one of the most revered temples of Nashik, dedicated to Lord Rama. Built in black stone by Sardar Rangarao Odhekar in the 18th century, it has a striking idol of Lord Rama carved from black stone. The temple is associated with Sant Ramdas and played a role in Dalit movements led by Dr. B.R. Ambedkar. Thousands gather here during Ram Navami. Kalaram Temple is Nashik’s symbol of devotion and history."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills, believed to be the birthplace of Lord Hanuman, are located near Trimbakeshwar. The trek to the hilltop is scenic with lush greenery, caves, and waterfalls in monsoon. The hill also has an ancient fort and temple. Pilgrims visit for its religious importance, while trekkers admire its natural beauty. Sunrise views from here are mesmerizing. Anjaneri is Nashik’s blend of mythology and adventure."
  },
  {
    "title": "Someshwar Waterfall",
    "description": "Someshwar Waterfall, also called Dudhsagar Waterfall of Nashik, is a popular picnic spot on the Godavari River. Located near Gangapur Road, it cascades beautifully, especially in the monsoon season. Families enjoy the serene surroundings and local snacks nearby. The nearby Someshwar Temple adds spiritual charm to the area. It is a favorite weekend retreat for locals. Someshwar Waterfall is Nashik’s refreshing natural attraction."
  },
  {
    "title": "Coin Museum",
    "description": "The Coin Museum in Nashik is the only one of its kind in Asia, dedicated to numismatics. It showcases coins, currency, and artifacts dating back to ancient and medieval India. Visitors learn about the history of trade, economy, and dynasties through currency. Educational tours and exhibits make it engaging for students and history lovers. It is managed by the Indian Institute of Research in Numismatic Studies. The Coin Museum is Nashik’s hub of history and knowledge."
  },
  {
    "title": "Kumbh Mela Grounds",
    "description": "Nashik is one of the four cities in India that hosts the grand Kumbh Mela every 12 years. Held on the banks of the Godavari at Trimbakeshwar and Ramkund, it attracts millions of pilgrims. Saints, sadhus, and devotees gather for the sacred bathing rituals. The mela is also known for religious discourses, processions, and fairs. It is one of the largest spiritual gatherings in the world. Kumbh Mela makes Nashik a global center of faith."
  }
],



       "services": [
    {
      "name": "Pune to Nasik Cab Service",
      "description": "Reliable and comfortable Pune to Nasik cab service offering timely pickups and safe, smooth journeys. Perfect for tourists, business travelers, and locals, our cabs are equipped with modern amenities to ensure a pleasant ride across this popular route."
    },
    {
      "name": "Affordable Cabs Pune to Nasik",
      "description": "Affordable and budget-friendly cab options from Pune to Nasik that balance cost-effectiveness with comfort and safety. Ideal for travelers looking for reliable transportation without breaking the bank, with transparent pricing and flexible packages."
    },
    {
      "name": "Pune to Nasik Sula Wine Yards",
      "description": "Specialized cab service from Pune to Nasik with focus on visiting the famous Sula Wine Yards. Enjoy a comfortable and leisurely trip with experienced drivers familiar with local routes and winery tours, making your wine tasting experience seamless and enjoyable."
    },
    {
      "name": "Pune to Nasik Car Rental",
      "description": "Flexible car rental options for the Pune to Nasik route, offering self-drive and chauffeur-driven vehicles. Choose from a variety of cars to suit your travel style, whether for business, leisure, or sightseeing."
    },
    {
      "name": "Pune Nasik Taxi Service",
      "description": "Dependable taxi service connecting Pune and Nasik with a fleet of clean, well-maintained cars. We provide punctual service and courteous drivers for local, airport, and outstation travel needs."
    },
    {
      "name": "Pune to Nasik Airport Cabs",
      "description": "Efficient airport cab transfers from Pune to Nasik ensuring timely arrivals and departures. Our drivers assist with luggage and provide comfortable rides, perfect for catching flights or returning from airports stress-free."
    },
    {
      "name": "Pune to Nasik Outstation Cabs",
      "description": "Reliable outstation cab services between Pune and Nasik that prioritize safety and comfort. Whether for a quick trip or extended journey, our vehicles and drivers are prepared to deliver a smooth experience."
    },
    {
      "name": "Pune to Nasik Cab Booking Online",
      "description": "Convenient online booking platform for Pune to Nasik cabs, offering instant confirmations, multiple payment options, and transparent pricing. Book your cab easily from anywhere at any time."
    },
    {
      "name": "Nasik Dudhsagar Water Falls Taxi",
      "description": "Special taxi services for trips from Nasik to the scenic Dudhsagar Water Falls. Enjoy a safe and comfortable ride with knowledgeable drivers who can also assist with local sightseeing and travel tips."
    },
    {
      "name": "Pune to Nasik Private Cabs",
      "description": "Exclusive private cab options from Pune to Nasik for personalized travel experiences. Perfect for families, couples, or business travelers seeking privacy, comfort, and flexible itineraries."
    },
    {
      "name": "Pune Nasik One-Way Taxi",
      "description": "One-way taxi services from Pune to Nasik providing convenient drop-offs without return trip requirements. Affordable and flexible options tailored for single journey travelers."
    },
    {
      "name": "Pune to Nasik Round Trip Cabs",
      "description": "Round trip cab bookings from Pune to Nasik ideal for day trips, corporate travel, or leisure tours. Enjoy fixed rates, seamless scheduling, and dedicated drivers for a hassle-free round journey."
    },
    {
      "name": "Pune to Nasik Cabs",
      "description": "Trusted cabs for Pune to Nasik travel with a wide variety of vehicle options to match your budget and preference. We emphasize punctuality, safety, and excellent customer service throughout the trip."
    },
    {
      "name": "Cab From Pune to Nasik",
      "description": "Reliable cab services offering comfortable rides from Pune to Nasik, catering to solo travelers, families, and corporate clients. Our professional drivers ensure smooth and timely journeys."
    },
    {
      "name": "Nashik to Pune Private Car",
      "description": "Private car services from Nashik to Pune providing exclusive rides with well-maintained vehicles and courteous drivers. Perfect for personalized travel and business needs."
    },
    {
      "name": "Nasik to Pune Cab Booking",
      "description": "Easy and quick online booking for Nasik to Pune cabs, guaranteeing instant confirmations, competitive prices, and hassle-free rides. Ideal for return travelers and commuters."
    },
    {
      "name": "Nasik to Pune cab Service",
      "description": "Efficient cab service from Nasik to Pune focused on safety, punctuality, and customer satisfaction. Choose from a range of vehicles to suit your travel plans."
    },
    {
      "name": "Nasik to Pune Cabs",
      "description": "Reliable and affordable cabs available from Nasik to Pune with professional drivers and clean vehicles. Suitable for all types of travelers including tourists, corporate clients, and locals."
    },
    {
      "name": "Nasik to Pune Taxi",
      "description": "Trusted taxi service from Nasik to Pune offering comfortable rides, on-time service, and courteous drivers. Book your taxi for local travel, airport transfers, and outstation trips."
    },
    {
      "name": "Pune Nashik Taxi",
      "description": "Comprehensive taxi services between Pune and Nashik with a focus on customer comfort and reliability. Choose from economy, premium, and luxury cars for your travel."
    },
    {
      "name": "Pune Nasik Cab",
      "description": "Professional Pune to Nasik cab services providing safe, timely, and comfortable rides. Perfect for one-way or round trips, with flexible booking options."
    },
    {
      "name": "Pune Nasik Taxi",
      "description": "Efficient taxi service for Pune to Nasik travel, featuring experienced drivers and a variety of vehicle choices. Ideal for airport transfers, sightseeing, and business travel."
    },
    {
      "name": "Pune to Nasik Taxi",
      "description": "Reliable taxi services from Pune to Nasik ensuring comfortable travel with trained drivers, clean vehicles, and competitive pricing. Perfect for personal and corporate trips."
    },
    {
      "name": "Taxi from Pune to Nasik",
      "description": "Hassle-free taxi service from Pune to Nasik with timely pickups, professional drivers, and well-maintained cars. Book easily for safe and comfortable intercity travel."
    },
    {
      "name": "Pune airports to Nasik cabs",
      "description": "Convenient cab services from Pune airports to Nasik offering door-to-door transfers, luggage assistance, and punctual service. Ideal for travelers landing in Pune and heading to Nasik."
    }
  ],
  "tableData": [
    ["Pune to Nasik Cab Service", "Affordable Cabs Pune to Nasik"],
    ["Pune to Nasik Sula wine yards", "Pune to Nasik Car Rental"],
    ["Pune Nasik Taxi Service", "Pune to Nasik Airport Cabs"],
    ["Pune to Nasik Outstation Cabs", "Pune to Nasik Cab Booking Online"],
    ["Nasik Dudhsagar Water Falls Taxi", "Pune to Nasik Private Cabs"],
    ["Pune Nasik One-Way Taxi", "Pune to Nasik Round Trip Cabs"],
    ["Pune to Nasik Cabs", "Cab From Pune to Nasik"],
    ["Nashik to Pune Private Car", "Nasik to Pune Cab Booking"],
    ["Nasik to Pune cab Service", "Nasik to Pune Cabs"],
    ["Nasik to Pune Taxi", "Pune Nashik Taxi"],
    ["Pune Nasik Cab", "Pune Nasik Taxi"],
    ["Pune to Nasik Taxi", "Taxi from Pune to Nasik"],
    ["Pune airports to Nasik cabs"]
  ],


 "whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Nasik Cabs for Comfortable Travel",
        "WhyChoosedescription": "Platinum24 Cabs provides cost-effective and reliable cab services for your journey from Pune to Nasik."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Long Trips",
        "WhyChoosedescription": "Travel in comfort with our well-maintained cabs designed for long-distance Pune to Nasik rides."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
        "WhyChoosedescription": "We ensure all our vehicles are regularly cleaned and sanitized before every trip for a safe travel experience."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our skilled drivers are familiar with the Pune to Nasik route, guaranteeing smooth and timely journeys."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
        "WhyChoosedescription": "Customize your travel plans with one-way, round-trip, or multi-day cab hire from Pune to Nasik."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for worry-free travel."
    },
    {
        "WhyChooseheading": "Ideal for Family Trips, Business Travel, and Group Tours",
        "WhyChoosedescription": "Our Pune to Nasik cab services cater to a variety of travel purposes, from leisure to corporate."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
        "WhyChoosedescription": "Our dedicated team is available around the clock to help with bookings, changes, and special requests."
    }
]













    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services from Pune to Nasik?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable cab services for travel between Pune and Nasik.',
    },
    {
        question: 'How can I book a Pune to Nasik cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Nasik cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Nasik trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel needs and budget.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Nasik?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Nasik route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Nasik?',
        answer: 'Absolutely! We provide round-trip options with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Nasik cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Nasik cab rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Nasik route.',
    },
    {
        question: 'Are there safety measures for Pune to Nasik cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Nasik travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel requirements.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Nasik?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Nasik routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Amit Joshi',
        feedback: 'I booked a cab from Pune to Nasik with Platinum24 Cabs. The ride was comfortable and the driver was very professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Kulkarni',
        feedback: 'Platinum24 Cabs made my Pune to Nasik trip smooth and hassle-free. Highly recommended for long-distance travel!',
        rating: 5,
    },
];






























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToNasikCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nasik Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-nasik-cab.jpg",
  "description": "Book reliable Pune to Nasik cabs with Platinum24 Cabs. Affordable taxi services for airport transfers, outstation trips, and round trips. Trusted drivers and 24/7 customer support available.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "21500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1250",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-nasik-cabs"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Nasik Cabs | Affordable Taxi & Airport Transfers | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable Pune to Nasik cabs with Platinum24 Cabs. Affordable taxi services for airport transfers, outstation trips, and round trips. Trusted drivers and 24/7 customer support available."
  />
  <meta
    name="keywords"
    content="Pune to Nasik Cab Service, Affordable Cabs Pune to Nasik, Pune to Nasik Sula wine yards, Pune to Nasik Car Rental, Pune Nasik Taxi Service, Pune to Nasik Airport Cabs, Pune to Nasik Outstation Cabs, Pune to Nasik Cab Booking Online, Nasik Dudhsagar Water Falls Taxi, Pune to Nasik Private Cabs, Pune Nasik One-Way Taxi, Pune to Nasik Round Trip Cabs, Pune to Nasik Cabs, Cab From Pune to Nasik, Nashik to Pune Private Car, Nasik to Pune Cab Booking, Nasik to Pune cab Service, Nasik to Pune Cabs, Nasik to Pune Taxi, Pune Nashik Taxi, Pune Nasik Cab, Pune Nasik Taxi, Pune to Nasik Taxi, Taxi from Pune to Nasik, Pune airports to Nasik cabs"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToNasikCabsSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/6.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonashikcabs;